import { render } from "./all-pilihan-ganda.vue?vue&type=template&id=f54c4fbe&scoped=true"
import script from "./all-pilihan-ganda.vue?vue&type=script&lang=js"
export * from "./all-pilihan-ganda.vue?vue&type=script&lang=js"

import "./all-pilihan-ganda.vue?vue&type=style&index=0&id=f54c4fbe&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54c4fbe"]])

export default __exports__